import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'

const TileSmall = ({
  link,
  alt,
  onMouseEnterHandler,
  onMouseLeaveHandler,
  className,
  children,
  click = () => {}
}) => (
  link ? (
    <ValuePropositionLink
      className={ className }
      to={ link }
      alt={ alt }
      onMouseEnter={ () => onMouseEnterHandler(alt) }
      onMouseLeave={ onMouseLeaveHandler } >
      {children}
    </ValuePropositionLink>
  )
    : (
      <ValueProposition
        className={ className }
        alt={ alt }
        role="link"
        tabIndex="0"
        onClick={ click }
        onMouseEnter={ () => onMouseEnterHandler(alt) }
        onMouseLeave={ onMouseLeaveHandler } >
        {children}
      </ValueProposition>
    )
)

TileSmall.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  click: PropTypes.func,
  link: PropTypes.string,
  onMouseEnterHandler: PropTypes.func,
  onMouseLeaveHandler: PropTypes.func
}

export default TileSmall

const ValueProposition = styled.div`
  padding: 35px 30px 32px;
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${Theme.colors.white};
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  ${Media.desktop`
    &:hover {
      background: ${Theme.colors.bright_red_new};
    }

    &:hover div {
      color: ${Theme.colors.white};
    }
  `}

  @media (max-width: 450px) {
    padding: 20px 15px;
  }
`

const ValuePropositionLink = styled(Link)`
  padding: 35px 30px 32px;
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${Theme.colors.white};
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  ${Media.desktop`
    &:hover {
      background: ${Theme.colors.bright_red_new};
    }

    &:hover div {
      color: ${Theme.colors.white};
    }
  `}

  @media (max-width: 450px) {
    padding: 20px 15px;
  }
`
